"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('bson'),
  ObjectId = _require.ObjectId;
var tv4 = require('tv4');
var EDGE_ROLE = require('../../constant/relationship/edge-role.constant');
var Edge = /*#__PURE__*/function () {
  function Edge(opt) {
    _classCallCheck(this, Edge);
    this._id = null;
    this.target = null;
    this.source = null;
    this.role = null;
    this.isActive = null;
    this.primary = null;
    this.startDate = null;
    this.endDate = null;
    this.events = null;
    if (opt) {
      this.fillObject(opt);
    }
  }
  _createClass(Edge, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.target = opt.target;
      this.source = opt.source;
      this.role = opt.role;
      this.startDate = opt.startDate ? new Date(opt.startDate) : new Date();
      this.endDate = opt.endDate ? new Date(opt.endDate) : null;
      this.events = (opt.events || []).map(function (e) {
        return {
          event: e.event,
          date: new Date(e.date)
        };
      });
      this.isActive = !this.endDate || this.endDate > new Date();
      this.primary = !!opt.primary;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Edge.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'edge.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'object'
          },
          target: {
            type: 'string'
          },
          source: {
            type: 'string'
          },
          role: {
            "enum": Object.keys(EDGE_ROLE)
          },
          isActive: {
            type: 'boolean'
          },
          primary: {
            type: 'boolean'
          },
          startDate: {
            type: 'object'
          },
          endDate: {
            type: ['object', 'null']
          },
          events: {
            type: 'array',
            items: {
              type: 'object'
            }
          }
        },
        required: Object.keys(new Edge())
      };
    }
  }]);
  return Edge;
}();
module.exports = Edge;